import React, { useState, useContext } from 'react';
import { LanguageContext } from '../App';
import { SearchIcon, FilterIcon, ChevronDownIcon, StarIcon, PhoneIcon, MessageSquareIcon, MapPinIcon, PlusIcon, DownloadIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { pageTransition, fadeIn, slideUp, staggerContainer, listItem, buttonHover, buttonTap } from '../utils/animations';
import { CountUp } from '../components/ui/CountUp';
export const Drivers: React.FC = () => {
  const {
    language
  } = useContext(LanguageContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [vehicleFilter, setVehicleFilter] = useState('all');
  const driverAvatars = ['https://i.ibb.co/xG0Jcnm/driver1.jpg', 'https://i.ibb.co/k2V6YPL/driver2.jpg', 'https://i.ibb.co/0hFTSyy/driver3.jpg', 'https://i.ibb.co/wdQSrBL/driver4.jpg', 'https://i.ibb.co/bRZmtTG/driver5.jpg'];
  const drivers = [{
    id: 'DRV-1001',
    name: 'Rahul Sharma',
    phone: '+965 9876 1234',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Salmiya, Block 10',
    orders: 145,
    rating: 4.9,
    earnings: 'KWD 1,245.50',
    joinDate: '2022-05-15',
    avatar: driverAvatars[0]
  }, {
    id: 'DRV-1002',
    name: 'Ahmed Khan',
    phone: '+965 9876 5678',
    status: 'active',
    vehicle: 'car',
    location: 'Kuwait City, Block 3',
    orders: 132,
    rating: 4.8,
    earnings: 'KWD 1,120.75',
    joinDate: '2022-06-20',
    avatar: driverAvatars[1]
  }, {
    id: 'DRV-1003',
    name: 'Farhan Qureshi',
    phone: '+965 9876 9012',
    status: 'inactive',
    vehicle: 'motorcycle',
    location: 'Hawally, Block 5',
    orders: 128,
    rating: 4.7,
    earnings: 'KWD 1,050.25',
    joinDate: '2022-07-10',
    avatar: driverAvatars[2]
  }, {
    id: 'DRV-1004',
    name: 'Arjun Patel',
    phone: '+965 9876 3456',
    status: 'active',
    vehicle: 'car',
    location: 'Jabriya, Block 1',
    orders: 98,
    rating: 4.6,
    earnings: 'KWD 875.50',
    joinDate: '2022-08-05',
    avatar: driverAvatars[3]
  }, {
    id: 'DRV-1005',
    name: 'Imran Malik',
    phone: '+965 9876 7890',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Kuwait City, Block 6',
    orders: 87,
    rating: 4.5,
    earnings: 'KWD 780.25',
    joinDate: '2022-09-15',
    avatar: driverAvatars[4]
  }, {
    id: 'DRV-1006',
    name: 'Ravi Kumar',
    phone: '+965 9876 2345',
    status: 'inactive',
    vehicle: 'car',
    location: 'Salmiya, Block 8',
    orders: 76,
    rating: 4.4,
    earnings: 'KWD 680.50',
    joinDate: '2022-10-20',
    avatar: driverAvatars[0]
  }, {
    id: 'DRV-1007',
    name: 'Sanjay Gupta',
    phone: '+965 9876 8765',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Hawally, Block 3',
    orders: 65,
    rating: 4.3,
    earnings: 'KWD 590.75',
    joinDate: '2022-11-05',
    avatar: driverAvatars[1]
  }, {
    id: 'DRV-1008',
    name: 'Anwar Javed',
    phone: '+965 9876 9876',
    status: 'active',
    vehicle: 'car',
    location: 'Kuwait City, Block 2',
    orders: 54,
    rating: 4.2,
    earnings: 'KWD 490.25',
    joinDate: '2022-12-10',
    avatar: driverAvatars[2]
  }, {
    id: 'DRV-1009',
    name: 'Vikram Singh',
    phone: '+965 9876 1122',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Jabriya, Block 4',
    orders: 43,
    rating: 4.1,
    earnings: 'KWD 390.50',
    joinDate: '2023-01-15',
    avatar: driverAvatars[3]
  }, {
    id: 'DRV-1010',
    name: 'Zahid Hussain',
    phone: '+965 9876 3344',
    status: 'inactive',
    vehicle: 'car',
    location: 'Salmiya, Block 5',
    orders: 32,
    rating: 4.0,
    earnings: 'KWD 290.75',
    joinDate: '2023-02-20',
    avatar: driverAvatars[4]
  }, {
    id: 'DRV-1011',
    name: 'Rajesh Mehta',
    phone: '+965 9876 5566',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Kuwait City, Block 7',
    orders: 28,
    rating: 3.9,
    earnings: 'KWD 250.25',
    joinDate: '2023-03-05',
    avatar: driverAvatars[0]
  }, {
    id: 'DRV-1012',
    name: 'Adnan Ali',
    phone: '+965 9876 7788',
    status: 'active',
    vehicle: 'car',
    location: 'Hawally, Block 9',
    orders: 24,
    rating: 3.8,
    earnings: 'KWD 220.50',
    joinDate: '2023-03-20',
    avatar: driverAvatars[1]
  }, {
    id: 'DRV-1013',
    name: 'Vijay Verma',
    phone: '+965 9876 9900',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Jabriya, Block 6',
    orders: 20,
    rating: 3.7,
    earnings: 'KWD 190.75',
    joinDate: '2023-04-05',
    avatar: driverAvatars[2]
  }, {
    id: 'DRV-1014',
    name: 'Nasir Khan',
    phone: '+965 9876 1133',
    status: 'inactive',
    vehicle: 'car',
    location: 'Salmiya, Block 12',
    orders: 18,
    rating: 3.6,
    earnings: 'KWD 170.25',
    joinDate: '2023-04-20',
    avatar: driverAvatars[3]
  }, {
    id: 'DRV-1015',
    name: 'Suresh Patel',
    phone: '+965 9876 2244',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Kuwait City, Block 9',
    orders: 15,
    rating: 3.5,
    earnings: 'KWD 150.50',
    joinDate: '2023-05-05',
    avatar: driverAvatars[4]
  }, {
    id: 'DRV-1016',
    name: 'Faisal Ahmad',
    phone: '+965 9876 3355',
    status: 'active',
    vehicle: 'car',
    location: 'Hawally, Block 11',
    orders: 12,
    rating: 3.4,
    earnings: 'KWD 130.75',
    joinDate: '2023-05-20',
    avatar: driverAvatars[0]
  }, {
    id: 'DRV-1017',
    name: 'Dinesh Kumar',
    phone: '+965 9876 4466',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Jabriya, Block 8',
    orders: 10,
    rating: 3.3,
    earnings: 'KWD 110.25',
    joinDate: '2023-06-05',
    avatar: driverAvatars[1]
  }, {
    id: 'DRV-1018',
    name: 'Waseem Raja',
    phone: '+965 9876 5577',
    status: 'inactive',
    vehicle: 'car',
    location: 'Salmiya, Block 14',
    orders: 8,
    rating: 3.2,
    earnings: 'KWD 90.50',
    joinDate: '2023-06-20',
    avatar: driverAvatars[2]
  }, {
    id: 'DRV-1019',
    name: 'Manoj Sharma',
    phone: '+965 9876 6688',
    status: 'active',
    vehicle: 'motorcycle',
    location: 'Kuwait City, Block 11',
    orders: 5,
    rating: 3.1,
    earnings: 'KWD 70.75',
    joinDate: '2023-07-05',
    avatar: driverAvatars[3]
  }, {
    id: 'DRV-1020',
    name: 'Tariq Aziz',
    phone: '+965 9876 7799',
    status: 'active',
    vehicle: 'car',
    location: 'Hawally, Block 13',
    orders: 3,
    rating: 3.0,
    earnings: 'KWD 50.25',
    joinDate: '2023-07-20',
    avatar: driverAvatars[4]
  }];
  // Filter drivers based on search term and filters
  const filteredDrivers = drivers.filter(driver => (statusFilter === 'all' || driver.status === statusFilter) && (vehicleFilter === 'all' || driver.vehicle === vehicleFilter) && (searchTerm === '' || driver.name.toLowerCase().includes(searchTerm.toLowerCase()) || driver.id.toLowerCase().includes(searchTerm.toLowerCase()) || driver.phone.includes(searchTerm) || driver.location.toLowerCase().includes(searchTerm.toLowerCase())));
  const getStatusClass = (status: string) => {
    return status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800';
  };
  const getStatusText = (status: string) => {
    if (language === 'en') {
      return status === 'active' ? 'Active' : 'Inactive';
    } else {
      return status === 'active' ? 'نشط' : 'غير نشط';
    }
  };
  const getVehicleText = (vehicle: string) => {
    if (language === 'en') {
      return vehicle === 'car' ? 'Car' : 'Motorcycle';
    } else {
      return vehicle === 'car' ? 'سيارة' : 'دراجة نارية';
    }
  };
  return <motion.div className="space-y-6" variants={pageTransition} initial="hidden" animate="visible" exit="exit" data-id="element-791">
      <motion.div className="flex justify-between items-center" variants={slideUp} data-id="element-792">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-793">
          {language === 'en' ? 'Drivers' : 'السائقين'}
          <span className="ml-2 text-sm font-medium text-gray-500" data-id="element-794">
            {filteredDrivers.length} {language === 'en' ? 'total' : 'إجمالي'}
          </span>
        </h2>
        <motion.div className="flex items-center space-x-2" variants={staggerContainer} data-id="element-795">
          <motion.button className="px-3 py-1.5 text-sm border border-gray-300 rounded-md flex items-center text-gray-700 hover:bg-gray-50 transition-colors" variants={listItem} whileHover={buttonHover} whileTap={buttonTap} data-id="element-796">
            <DownloadIcon size={14} className="mr-1" data-id="element-797" />
            {language === 'en' ? 'Export' : 'تصدير'}
          </motion.button>
          <motion.button className="px-3 py-1.5 text-sm bg-congress-blue-600 text-white rounded-md flex items-center hover:bg-congress-blue-700 transition-colors" variants={listItem} whileHover={buttonHover} whileTap={buttonTap} data-id="element-798">
            <PlusIcon size={14} className="mr-1" data-id="element-799" />
            {language === 'en' ? 'Add Driver' : 'إضافة سائق'}
          </motion.button>
        </motion.div>
      </motion.div>
      {/* Stats Cards */}
      <motion.div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" variants={fadeIn} data-id="element-800">
        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-801">
          <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-802">
            {language === 'en' ? 'Total Drivers' : 'إجمالي السائقين'}
          </div>
          <div className="text-2xl font-bold text-gray-900" data-id="element-803">
            <CountUp to={120} data-id="element-804" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-805">
          <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-806">
            {language === 'en' ? 'Active Drivers' : 'السائقين النشطين'}
          </div>
          <div className="text-2xl font-bold text-green-600" data-id="element-807">
            <CountUp to={98} data-id="element-808" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-809">
          <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-810">
            {language === 'en' ? 'Average Rating' : 'متوسط التقييم'}
          </div>
          <div className="text-2xl font-bold text-yellow-600 flex items-center" data-id="element-811">
            <CountUp to={4.7} decimals={1} data-id="element-812" />
            <StarIcon size={18} className="ml-1" data-id="element-813" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-814">
          <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-815">
            {language === 'en' ? 'Total Deliveries' : 'إجمالي التوصيلات'}
          </div>
          <div className="text-2xl font-bold text-congress-blue-600" data-id="element-816">
            <CountUp to={500} data-id="element-817" />
          </div>
        </div>
      </motion.div>
      <motion.div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" variants={fadeIn} data-id="element-818">
        <motion.div className="px-4 py-3 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" variants={slideUp} data-id="element-819">
          <motion.div className="relative w-full sm:w-64" initial={{
          opacity: 0,
          width: '90%'
        }} animate={{
          opacity: 1,
          width: '100%'
        }} transition={{
          duration: 0.3
        }} data-id="element-820">
            <input type="text" placeholder={language === 'en' ? 'Search drivers...' : 'البحث عن سائقين...'} className="w-full px-9 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-congress-blue-500 focus:border-congress-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-821" />
            <SearchIcon size={16} className="absolute left-3 top-2 text-gray-400" data-id="element-822" />
          </motion.div>
          <motion.div className="flex flex-wrap gap-2" variants={staggerContainer} data-id="element-823">
            <motion.div className="relative" variants={listItem} data-id="element-824">
              <select className="appearance-none px-3 py-1.5 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-congress-blue-500 focus:border-congress-blue-500" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-825">
                <option value="all" data-id="element-826">
                  {language === 'en' ? 'All Status' : 'جميع الحالات'}
                </option>
                <option value="active" data-id="element-827">
                  {language === 'en' ? 'Active' : 'نشط'}
                </option>
                <option value="inactive" data-id="element-828">
                  {language === 'en' ? 'Inactive' : 'غير نشط'}
                </option>
              </select>
              <ChevronDownIcon size={14} className="absolute right-2.5 top-2.5 text-gray-500 pointer-events-none" data-id="element-829" />
            </motion.div>
            <motion.div className="relative" variants={listItem} data-id="element-830">
              <select className="appearance-none px-3 py-1.5 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-congress-blue-500 focus:border-congress-blue-500" value={vehicleFilter} onChange={e => setVehicleFilter(e.target.value)} data-id="element-831">
                <option value="all" data-id="element-832">
                  {language === 'en' ? 'All Vehicles' : 'جميع المركبات'}
                </option>
                <option value="car" data-id="element-833">
                  {language === 'en' ? 'Cars' : 'سيارات'}
                </option>
                <option value="motorcycle" data-id="element-834">
                  {language === 'en' ? 'Motorcycles' : 'دراجات نارية'}
                </option>
              </select>
              <ChevronDownIcon size={14} className="absolute right-2.5 top-2.5 text-gray-500 pointer-events-none" data-id="element-835" />
            </motion.div>
            <motion.button className="px-3 py-1.5 bg-gray-50 text-gray-700 rounded-md flex items-center hover:bg-gray-100 transition-colors text-sm border border-gray-200" variants={listItem} whileHover={buttonHover} whileTap={buttonTap} data-id="element-836">
              <FilterIcon size={14} className={language === 'en' ? 'mr-1.5' : 'ml-1.5'} data-id="element-837" />
              {language === 'en' ? 'More Filters' : 'المزيد من الفلاتر'}
            </motion.button>
          </motion.div>
        </motion.div>
        <div className="overflow-x-auto" data-id="element-838">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-839">
            <thead data-id="element-840">
              <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-841">
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-842">
                  {language === 'en' ? 'Driver' : 'السائق'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-843">
                  {language === 'en' ? 'Contact' : 'معلومات الاتصال'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-844">
                  {language === 'en' ? 'Status' : 'الحالة'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-845">
                  {language === 'en' ? 'Vehicle' : 'المركبة'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-846">
                  {language === 'en' ? 'Location' : 'الموقع'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200 text-center" data-id="element-847">
                  {language === 'en' ? 'Orders' : 'الطلبات'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200 text-center" data-id="element-848">
                  {language === 'en' ? 'Rating' : 'التقييم'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200 text-right" data-id="element-849">
                  {language === 'en' ? 'Earnings' : 'الأرباح'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200 text-right" data-id="element-850">
                  {language === 'en' ? 'Actions' : 'الإجراءات'}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100" data-id="element-851">
              {filteredDrivers.map((driver, index) => <motion.tr key={driver.id} className="hover:bg-gray-50" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0,
              transition: {
                delay: index * 0.05,
                duration: 0.3
              }
            }} whileHover={{
              backgroundColor: 'rgba(249, 250, 251, 0.5)'
            }} data-id="element-852">
                  <td className="px-4 py-3 whitespace-nowrap" data-id="element-853">
                    <div className="flex items-center" data-id="element-854">
                      <div className="flex-shrink-0 h-8 w-8 rounded-full overflow-hidden" data-id="element-855">
                        <img src={driver.avatar} alt={driver.name} className="w-full h-full object-cover" data-id="element-856" />
                      </div>
                      <div className="ml-3" data-id="element-857">
                        <div className="font-medium text-gray-900" data-id="element-858">
                          {driver.name}
                        </div>
                        <div className="text-gray-500 text-xs" data-id="element-859">{driver.id}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-860">
                    {driver.phone}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap" data-id="element-861">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${getStatusClass(driver.status)}`} data-id="element-862">
                      <span className={`h-1.5 w-1.5 rounded-full ${driver.status === 'active' ? 'bg-green-500' : 'bg-red-500'} mr-1`} data-id="element-863"></span>
                      {getStatusText(driver.status)}
                    </span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-864">
                    {getVehicleText(driver.vehicle)}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-865">
                    <div className="flex items-center" data-id="element-866">
                      <MapPinIcon size={14} className="mr-1 text-gray-400" data-id="element-867" />
                      {driver.location}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center font-medium" data-id="element-868">
                    <CountUp to={driver.orders} data-id="element-869" />
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-center" data-id="element-870">
                    <div className="flex items-center justify-center text-sm text-yellow-500 font-medium" data-id="element-871">
                      <StarIcon size={16} className="mr-1" data-id="element-872" />
                      <CountUp to={driver.rating} decimals={1} data-id="element-873" />
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right font-medium" data-id="element-874">
                    {driver.earnings}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-right" data-id="element-875">
                    <div className="flex justify-end space-x-1" data-id="element-876">
                      <motion.button className="p-1.5 text-congress-blue-600 bg-congress-blue-50 hover:bg-congress-blue-100 rounded transition-colors" title={language === 'en' ? 'View Profile' : 'عرض الملف'} whileHover={{
                    scale: 1.1
                  }} whileTap={{
                    scale: 0.95
                  }} data-id="element-877">
                        <StarIcon size={16} data-id="element-878" />
                      </motion.button>
                      <motion.button className="p-1.5 text-green-600 bg-green-50 hover:bg-green-100 rounded transition-colors" title={language === 'en' ? 'Call Driver' : 'اتصال بالسائق'} whileHover={{
                    scale: 1.1
                  }} whileTap={{
                    scale: 0.95
                  }} data-id="element-879">
                        <PhoneIcon size={16} data-id="element-880" />
                      </motion.button>
                      <motion.button className="p-1.5 text-regent-st-blue-600 bg-regent-st-blue-50 hover:bg-regent-st-blue-100 rounded transition-colors" title={language === 'en' ? 'Message Driver' : 'إرسال رسالة للسائق'} whileHover={{
                    scale: 1.1
                  }} whileTap={{
                    scale: 0.95
                  }} data-id="element-881">
                        <MessageSquareIcon size={16} data-id="element-882" />
                      </motion.button>
                    </div>
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between" data-id="element-883">
          <div className="text-xs text-gray-500" data-id="element-884">
            {language === 'en' ? `Showing 1 to ${filteredDrivers.length} of ${drivers.length} drivers` : `عرض 1 إلى ${filteredDrivers.length} من ${drivers.length} سائق`}
          </div>
        </div>
      </motion.div>
    </motion.div>;
};